<template>
  <div data-app class="tm-scheduletable" :class="role">
    <div class="uk-card uk-card-default uk-card-small uk-margin uk-animation-fade" style="min-height: calc(100vh - 0px);">
      <!--шапка + пагинация + кнопка сброса-->
      <div class="uk-card-header">
        <div class="uk-grid uk-child-width-auto uk-flex-middle" data-uk-grid>
          <div>
            <h3 class="uk-card-title uk-margin-remove-top">
              {{local_page_keys.title_page_timetable}}
            </h3>
          </div>
          <div class="uk-width-expand">
            <div v-if="isAdmin()" class="users_list uk-width-large">
              <v-select
                  :options="users_list"
                  label="text"
                  :reduce="user => user.value"
                  @input="changeUser"
                  :clearable="false"
                  class="tm-v-select">
              </v-select>
            </div>
          </div>
          <!--пагинация + кнопка сброса-->
          <div>
            <div class="uk-grid uk-flex-middle uk-flex-center" data-uk-grid>
              <!--пагинация-->
              <div>
                <div class="pagination">
                  <pagination v-if="isAdmin()" class="text-center" :total="53" :page-count="53" :value="page" :type="currentPage(page)" @input-child="changePage"></pagination>
                </div>
              </div>
              <!--кнопка сброса-->
              <div v-if="isAdmin() && week !== page">
                <button
                    class="uk-button uk-button-success"
                    @click="backToCurrWeek"
                    data-uk-tooltip="title: Вернться на текущую неделю">
                  <md-icon>update</md-icon>
                  <!--              {{local_page_keys.label_return}}-->
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--таблица-->
      <div class="uk-margin-bottom">
        <md-table v-model="schedules" table-header-color="black" class="schedule schedule-table font">
          {{page}}
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <!--первая ячейка в строке-->
            <md-table-cell :md-label="local_page_keys.label_kiev_time">
              {{ item[0] }}
              <!--отметка ночного времени-->
              <span v-if="isNight(item[0])" :data-uk-tooltip="local_page_keys.schedule_tooltip_moon_description"><i class="md-icon tm-scheduletable-icon">bedtime</i></span>
              <!--отметка текущего времени-->
              {{currentShiftTime(item[0])}}
            </md-table-cell>

            <md-table-cell
                v-for="day in filterDaysToShow(Object.entries(item[1]))"
                :key="day.worker"
                :md-label="getLabel(day[0]) + (isAdmin() ? getCountOrder(day[0]): '')"
                :class="getClass(day[0])"
                :id="'cell-'+day[0]+item[0]">

              <!--прилодер для ячейки-->
              <div class="loader-hide" :id="'cell-loader-'+day[0]+item[0]">
                <v-progress-circular :width="2" :size="20" indeterminate style="color: forestgreen"/>
              </div>

              <!--кнопка ЗАПИСАТЬ-->
              <button v-if="!isPast(day[0], item[0]) && isAdminView() && !isMember(day[1])"
                      type="button"
                      class="uk-button tm-button-schedule-table tm-button-scheduletable-success 111"
                      @click="showDialog(day[0], item[0], 'subscribe')">
                {{ local_page_keys.button_recorded_by }}
              </button>

              <!--кнопка с выпадающим блоком-->
              <div v-if="isAdmin() && !isAdminView()">
                <button
                  v-if="timeControl[item[0]] !== undefined && timeControl[item[0]] !== undefined && timeControl[item[0]][day[0]] !== undefined"
                  type="button"
                  @click="initToggleDelay(item[0],day[0])"
                  @focusout="activeButtonId = ''"
                  class="uk-button tm-button-schedule-table 222"
                  :class="getTimeControlClass(item[0],day[0])"
                  :id="'button-'+day[0]+item[0]"
                  :data-uk-tooltip="getToolTip(timeControl[item[0]][day[0]],getRetoucherTime(day[1], day[0], item[0]).length)">
                  <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                    <div>
                      <div class="tm-button-scheduletable-cell">
                        {{ timeControl[item[0]][day[0]].all }}({{ timeControl[item[0]][day[0]].use }}) {{currentShift(day[0],item[0])}}
                      </div>
                    </div>
                    <template v-if="isPast(day[0], item[0])">
                      <div class="tm-button-scheduletable-cell">
                        {{timeControl[item[0]][day[0]].all_current}}({{timeControl[item[0]][day[0]].order_done_in_shift}})
                      </div>
                      <div class="tm-button-scheduletable-cell" :class ='{"tm-text-underline" : timeControl[item[0]][day[0]].waiting_minutes > getRetoucherTime(day[1], day[0], item[0]).length * 15}'>
                        {{timeControl[item[0]][day[0]].waiting_minutes}}'
                      </div>
                    </template>
                  </div>
                </button>
                <!--кнопка НЕТ ДАННЫХ ??-->
                <button
                    v-else
                    type="button"
                    style="border-radius: 4px"
                    class="uk-button uk-button-default tm-button-schedule-table 333">
                  {{local_page_keys.button_no_data}}<i aria-hidden="true" class="v-icon notranslate mdi mdi-menu-down theme--light" style="color: black !important;"></i>
                </button>

                <!--выпадающий блок-->
                <div @click="initToggleDelayPopup(item[0],day[0])"  :id="'tm-scheduletable-dropdown-'+day[0]+item[0]" class="uk-dropdown tm-scheduletable-dropdown " data-uk-dropdown="mode: click; offset: 5" :class="getBackground(timeControl[item[0]][day[0]],ordersDelay[item[0]][day[0]])">

                  <div v-if="getRetoucherTime(day[1], day[0], item[0]).length > 0"
                       :id="day[0]+item[0]"
                       class="uk-grid uk-grid-collapse uk-grid-divider"
                       data-uk-grid>
                    <div class="tm-scheduletable-dropdown-box1">
                      <!--шапка1-->
                      <div class="tm-scheduletable-dropdown-list-head">
                        <div class="uk-grid uk-grid-collapse">
                          <div class="tm-scheduletable-dropdown-list-width-small">
                            <div class="tm-scheduletable-dropdown-list-cell" data-uk-tooltip="Прогнозируемая производительность ретушера">
                              <i class="md-icon tm-scheduletable-icon">trending_up</i>
                            </div>
                          </div>
                          <div class="uk-width-expand">
                            <div class="tm-scheduletable-dropdown-list-cell uk-text-left" data-uk-tooltip="ФИО ретушера">
                              Retoucher
                            </div>
                          </div>
                          <div class="tm-scheduletable-dropdown-list-width-small">
                            <div class="tm-scheduletable-dropdown-list-cell" data-uk-tooltip="Фактическое кол-во заказов, выполненное ретушером">
                              <i class="md-icon tm-scheduletable-icon">numbers</i>
                            </div>
                          </div>
                          <div class="tm-scheduletable-dropdown-list-width-small">
                            <div class="tm-scheduletable-dropdown-list-cell" data-uk-tooltip="Кол-во минут простоя у ретушера">
                              <i class="md-icon tm-scheduletable-icon">schedule</i>
                            </div>
                          </div>
                          <div class="tm-scheduletable-dropdown-list-width-small">
                            <div class="tm-scheduletable-dropdown-list-cell" data-uk-tooltip="Рачетное значение минут работы(включая простой) на смене">
                              <i class="md-icon tm-scheduletable-icon">battery_charging_full</i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--таблица1-->
                      <div class="uk-panel-scrollable tm-scheduletable-dropdown-list-scrollable">
                        <div v-for="worker in getRetoucherTime(day[1], day[0], item[0])" :key="worker.id">
                          <ScheduleTable2RetoucherItem
                              v-if="worker['name'] !== '' && worker['email'] !==''"
                              :worker="worker"
                              :day="day"
                              :item="item"
                              :local_page_keys="local_page_keys"
                              :keyLockIsChecked="keyLockIsChecked"
                              :keyLockIstoSet="keyLockIstoSet"
                              :showDialog="showDialog"></ScheduleTable2RetoucherItem>
                        </div>
                      </div>
                    </div>

                    <div v-if="Object.entries(ordersDelay[item[0]][day[0]]).length" class="tm-scheduletable-dropdown-box2">
                      <!--шапка2-->
                      <div class="tm-scheduletable-dropdown-list-head">
                        <div class="uk-grid uk-grid-collapse">
                          <div class="uk-width-expand">
                            <div class="tm-scheduletable-dropdown-list-cell uk-text-left" data-uk-tooltip="Shift with delay">
                              Shift with delay
                            </div>
                          </div>
                          <div class="tm-scheduletable-dropdown-list-width-small">
                            <div class="tm-scheduletable-dropdown-list-cell" data-uk-tooltip="Кол-во минут ожидания клиентами">
                              <i class="md-icon tm-scheduletable-icon">schedule</i>
                            </div>
                          </div>
                          <div class="tm-scheduletable-dropdown-list-width-small">
                            <div class="tm-scheduletable-dropdown-list-cell" data-uk-tooltip="Фактическое кол-во заказов">
                              <i class="md-icon tm-scheduletable-icon">numbers</i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--таблица2-->
                      <div class="uk-panel-scrollable tm-scheduletable-dropdown-list-scrollable">
                        <div v-for="(delay) in ordersDelay[item[0]][day[0]]" :key="delay.id">
                          <div @click="toggleDelay(delay,item[0],day[0])">
                            <div class="uk-grid uk-grid-collapse uk-flex-middle tm-scheduletable-dropdown-list" :class="{'tm-active': delay.id  ===  selectedDelay.id }" style="cursor: pointer">
                              <div class="uk-width-expand uk-text-left">
                                <div class="tm-scheduletable-dropdown-list-cell tm-scheduletable-dropdown-list-cell-bg uk-text-bold">
                                  {{ delay.notification_time.split(" ")[1].slice(0, 5) }}
                                </div>
                              </div>
                              <div class="tm-scheduletable-dropdown-list-width-small">
                                <div class="tm-scheduletable-dropdown-list-cell tm-scheduletable-dropdown-list-cell-bg uk-text-bold">
                                  {{ delay.time_delay }}
                                </div>
                              </div>
                              <div class="tm-scheduletable-dropdown-list-width-small">
                                <div class="tm-scheduletable-dropdown-list-cell tm-scheduletable-dropdown-list-cell-bg uk-text-bold">
                                  {{ delay.number_delay_orders }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="Object.entries(ordersDelay[item[0]][day[0]]).length"  class="tm-scheduletable-dropdown-box3">
                      <!--шапка3-->
                      <div class="tm-scheduletable-dropdown-list-head">
                        <div class="uk-grid uk-grid-collapse">
                          <div class="uk-width-expand">
                            <div class="tm-scheduletable-dropdown-list-cell uk-text-left" data-uk-tooltip="Номер заказа">
                              Order #
                            </div>
                          </div>
                          <div class="tm-scheduletable-dropdown-list-width-small">
                            <div class="tm-scheduletable-dropdown-list-cell" data-uk-tooltip="Кол-во минут ожидания клиентом">
                              <i class="md-icon tm-scheduletable-icon">schedule</i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--таблица3-->
                      <div class="loader-hide" :id="'delay-loader-'+day[0]+item[0]">
                        <v-progress-circular :width="2" :size="20" indeterminate style="color: forestgreen"/>
                      </div>
                      <div v-if="!isDelayLoading">
                        <div v-if="selectedDelay.delay_json !== null" class="uk-panel-scrollable tm-scheduletable-dropdown-list-scrollable">
                          <div v-for="delayJson in JSON.parse(selectedDelay.delay_json)" :key="delayJson.order_id">
                            <div @click="openOrder(delayJson.order_id)" class="uk-grid uk-grid-collapse uk-flex-middle tm-scheduletable-dropdown-list" style="cursor: pointer;">
                              <div class="uk-width-expand uk-text-left">
                                <div class="tm-scheduletable-dropdown-list-cell tm-scheduletable-dropdown-list-cell-bg uk-text-bold">
                                  {{ delayJson.order_id }}
                                </div>
                              </div>
                              <div class="tm-scheduletable-dropdown-list-width-small">
                                <div class="tm-scheduletable-dropdown-list-cell tm-scheduletable-dropdown-list-cell-bg uk-text-bold">
                                  {{ delayJson.minutes_in_work }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-else>{{ local_page_keys.button_no_data }}</div>
                      </div>
                    </div>
                  </div>

                  <div v-else class="uk-padding-xsmall uk-text-center">No Data</div>
                  <!--выбор ретушеров-->
                  <div v-if="!isPast(day[0], item[0])" class="uk-padding-xsmall" :class="getBackground(timeControl[item[0]][day[0]])">
                    <div class="uk-grid uk-grid-small uk-child-width-auto uk-flex-middle" data-uk-grid>
                      <div>
                        <md-icon>add</md-icon>
                      </div>
                      <!--выпадающий список ретушеров-->
                      <div class="uk-width-expand">
                        <select name="users_choise_list"
                                class="uk-select"
                                :id="'select' + day[0]+item[0]"
                                @change="selectUser"
                                @input="selectObjId = (day[0]+item[0])">
                          <option value="">
                            {{local_page_keys.label_select_an_employee }}
                          </option>
                          <option v-for="user in getUsersList(item[0], day[0])"
                                  :key="user.item" :name="user.name"
                                  :value="user.value">
                            [{{ user.photos_per_hour }}]
                            {{ user.text }}
                          </option>
                        </select>
                      </div>
                      <!--замок-->
                      <div v-if="selectObj !== '' && selectObjId === (day[0]+item[0])">
                        <label class="custom-checkbox_" style="cursor: pointer;" :data-uk-tooltip="keyLockIstoSet  ? 'title: lock; offset: 10;' : 'title: lock open; offset: 10;'">
                          <input type="checkbox" v-model="keyLockIstoSet" style="position: absolute;display: none;">
                          <md-icon>{{ keyLockIstoSet  ? 'lock' : 'lock_open' }}</md-icon>
                        </label>
                      </div>
                      <!--кнопка-->
                      <div v-if="selectObj !== '' && selectObjId === (day[0]+item[0])">
                        <button
                            @click="showDialog(day[0], item[0], 'subscribe', selectObj)"
                            class="uk-button uk-button-small uk-button-success tm-button-schedule-table button-for-chooseUser"
                            style="color: #fff !important;">
                          {{local_page_keys.button_recorded_by}}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!--индикация ожиданий-->
                <div  v-if="isAdmin()" v-html="getWaitingIndication(ordersDelay[item[0]][day[0]])"></div>
              </div>

              <!--??-->
              <div v-else-if="!isAdmin() || isAdminView()" class="uk-text-center 0">
                <div class="uk-grid uk-grid-small uk-child-width-auto uk-flex-middle uk-flex-center uk-text-center" data-uk-grid>
                  <div v-if="isPast(day[0], item[0]) && isMember(day[1])" hidden>
                    ✅
                  </div>
                  <div hidden>
                    ( {{ getTime(day[1]) }} )
                  </div>
                </div>
              </div>

              <!--записан с зеленым человечком (ретушер)-->
              <div class="uk-text-center 1" v-if="!isAdmin() && !isPast(day[0], item[0]) && isMember(day[1]) && mayToWrite(day[0]) ">
                <div>
                  <span v-if="mayToReplace(day[1])" class="pointer">
                    {{local_page_keys.label_recorded_by}}
                  </span>
                  <span v-else-if="!mayToReplace(day[1]) && !mustCancelReplace(day[1])"  class="pointer">
                    {{local_page_keys.label_recorded_by}}
                  </span>
                  <span v-else-if="mustCancelReplace(day[1])">
                    {{local_page_keys.label_recorded_by}}
                  </span>
                  <span v-if="mustCancelReplace(day[1])" class="pointer">
                    🔄
                  </span>
                </div>
              </div>
              <!--Записан + замочек (ретушер)-->
              <div class="uk-text-center 2" v-else-if="isAdminView() && !isPast(day[0], item[0]) && isMember(day[1]) && !mustCancelReplace(day[1])">
                <div>
                  <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                    <!--надпись ЗАПИСАН-->
                    <div v-if="mayToReplace(day[1])" @click="showDialog(day[0], item[0], 'unsubscribe')" class="pointer">
                      {{local_page_keys.label_recorded_by}}
                    </div>
                  </div>
                </div>
              </div>
              <!--Записан + замочек + сервый человечек (ретушер)-->
              <div class="uk-text-center 3" v-else-if="!isAdmin() && !isPast(day[0], item[0]) && !mayToWrite(day[0]) && isMember(day[1]) ">
                <div>
                  <span v-if="!mustCancelReplace(day[1])" class="pointer">
                    {{local_page_keys.label_recorded_by}}
                  </span>
                  <span v-else-if="mustCancelReplace(day[1])">
                    {{local_page_keys.label_recorded_by}}
                  </span>
                  <span v-if="mustCancelReplace(day[1])" class="pointer">
                    🔄
                  </span>
                </div>
              </div>
              <div class="uk-text-center 4" v-else-if="isAdminView() && !isPast(day[0], item[0]) && mustCancelReplace(day[1]) && isMember(day[1]) ">
                <div>
                  <span>
                    {{local_page_keys.label_recorded_by}}77
                  </span>
                  <span v-if="mustCancelReplace(day[1])" @click="showDialog(day[0], item[0], 'cancell of replacement by admin')" class="pointer">
                    🔄
                  </span>
                </div>
              </div>
              <!--батарейка + показатели-->
              <div class="uk-text-center 5" v-else>
                <div v-if="isPast(day[0], item[0]) && (isMember(day[1]) || isFakeMember(day[1]))">
                  <div v-if="!isAdmin() || isAdminView()">
                    <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center" data-uk-grid>
                      <div>
                        <!--{{getWaitingTime(day[1])}}-->
                        <span v-if="isAdmin()">#{{getWaitingTime(day[1], true)['doneOrders']}}</span> <span>🕛{{getWaitingTime(day[1], true)['waitingTime']}}</span>
                      </div>
                      <div>
                        <div class="uk-grid uk-child-width-auto uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                          <!--описание для админа-->
                          <div v-if="isAdmin()" class="batteryOuter" :class="getClassBattery(getTime(day[1]), day[1]) + (isFakeMember(day[1]) ? ' tm-battery-black ': '')">
                            <div class="uk-grid uk-child-width-1-4 uk-flex-middle" data-uk-grid :data-battery="getTime(day[1])">
                              <div class="uk-text-danger uk-text-center uk-width-1-1" style="line-height: 10px;font-size: 8px;" v-if="getTime(day[1]) === 0 && !day[1][0].done_orders">
                                {{local_page_keys.scheduletable_empty}}
                              </div>
                              <div v-if="getTime(day[1]) > 0">
                                <div class="batteryLevel"></div>
                              </div>
                              <div v-if="getTime(day[1]) > 15">
                                <div class="batteryLevel"></div>
                              </div>
                              <div v-if="getTime(day[1]) > 29">
                                <div class="batteryLevel"></div>
                              </div>
                              <div v-if="getTime(day[1]) > 45">
                                <div class="batteryLevel"></div>
                              </div>
                            </div>
                          </div>
                          <!--описание для не админа-->
                          <div v-else class="batteryOuter" :class="getClassBattery(getTime(day[1]), day[1]) + (isFakeMember(day[1]) ? ' tm-battery-black ': '')">
                            <div class="uk-grid uk-child-width-1-4 uk-flex-middle" data-uk-grid :data-battery="getTime(day[1])">
                              <div class="uk-text-danger uk-text-center uk-width-1-1" style="line-height: 10px;font-size: 8px;" v-if="getTime(day[1]) === 0 && !day[1][0].done_orders">
                                {{local_page_keys.scheduletable_empty}}
                              </div>
                              <div v-if="getTime(day[1]) > 0">
                                <div class="batteryLevel"></div>
                              </div>
                              <div v-if="getTime(day[1]) > 15">
                                <div class="batteryLevel"></div>
                              </div>
                              <div v-if="getTime(day[1]) > 29">
                                <div class="batteryLevel"></div>
                              </div>
                              <div v-if="getTime(day[1]) > 45">
                                <div class="batteryLevel"></div>
                              </div>
                            </div>
                          </div>
                          <div class="batteryBump"></div>
                        </div>
                      </div>
                    </div>
                    <!--всплывающее описание-->
                    <div class="uk-dropdown tm-scheduletable-battery-dropdown" data-uk-dropdown="mode: hover; pos: bottom-left; offset: 5; delay-show: 300; shift: true" style="padding: 0;">
                      <div class="uk-padding-xsmall">
                        <div class="tm-grid-xsmall uk-grid-small uk-child-width-1-1 uk-text-left" data-uk-grid>
                          <div v-if="isAdmin()">
                            #{{getWaitingTime(day[1], true)['doneOrders']}} - фактические кол-во выполенных заказов
                          </div>
                          <div>
                            🕛{{getWaitingTime(day[1], true)['waitingTime']}} - кол-во минут простоя
                          </div>
                          <!--мини батарейка-->
                          <div>
                            <div class="uk-grid uk-grid-collapse" data-uk-grid>
                              <div class="uk-width-auto">
                                <div class="batteryOuter" :class="getClassBattery(getTime(day[1])) + (isFakeMember(day[1]) ? ' tm-battery-black ': '')">
                                  <div class="uk-grid uk-child-width-1-4 uk-flex-middle" data-uk-grid>
                                    <div class="uk-text-danger uk-text-center uk-width-1-1" style="line-height: 6px;font-size: 7px;" v-if="getTime(day[1]) === 0">
                                      {{local_page_keys.scheduletable_empty}}
                                    </div>
                                    <div v-if="getTime(day[1]) > 0">
                                      <div class="batteryLevel"></div>
                                    </div>
                                    <div v-if="getTime(day[1]) > 15">
                                      <div class="batteryLevel"></div>
                                    </div>
                                    <div v-if="getTime(day[1]) > 29">
                                      <div class="batteryLevel"></div>
                                    </div>
                                    <div v-if="getTime(day[1]) > 45">
                                      <div class="batteryLevel"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="uk-width-expand" style="line-height: 1.1">
                                <template v-if="isAdmin()">{{getTime(day[1])}}</template> - расчетное значение минут работы(включая простой) на этой смене
                              </div>
                            </div>
                          </div>
                          <!--описание-->
                          <div v-if="!isAdmin()">
                            {{ getDiscBattery2(getTime(day[1])) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </md-table-cell>
          </md-table-row>
        </md-table>
        <!--прилодер для всей таблицы-->
        <div v-if="loading" class="uk-flex uk-flex-center uk-flex-middle uk-overlay uk-overlay-primary uk-position-cover uk-position-z-index">
          <v-progress-circular
              :width="2"
              :size="100"
              indeterminate
              style="color: #fff"></v-progress-circular>
        </div>
        <div v-else-if="!loading && empty_schedule !== ''">
          <h2>{{ empty_schedule}}</h2>
        </div>
      </div>
    </div>

    <!--бонусы для ретушеров по дате-->
    <div class="uk-card uk-card-default uk-animation-fade" v-if="role === 'admin' || role ==='mini-admin' || role === 'senior-retoucher'">
      <div class="uk-card-header">
        <h3 class="uk-card-title uk-margin-remove">
          {{ local_page_keys.title_holidays_calendar}}
        </h3>
      </div>
      <div class="uk-padding-small">
        <AdminCalendarComponent :local_page_keys="local_page_keys"></AdminCalendarComponent>
      </div>
    </div>

    <!--Просмотр заказа-->
    <md-dialog
        :md-active.sync="showDialogOrder"
        :md-closed="true"
        :md-clicked-outside="true"
        :md-close-on-esc="true"
        class="tm-dialog-progress-report">
      <div class="uk-grid uk-flex-middle" data-uk-grid>
        <div class="uk-width-1-2">
          <v-tabs v-model="tabInfo">
            <v-tab>
              {{ local_page_keys.tab_title_history_order}}
            </v-tab>
            <v-tab>
              {{ local_page_keys.tab_title_info_order}}
            </v-tab>
          </v-tabs>
        </div>
        <div class="uk-width-1-2 uk-text-center">
          <!--переключение между заказами-->
          <div class="uk-grid uk-grid-small uk-flex-center uk-flex-middle" data-uk-grid>
            <div>
              <a href="#"
                 :disabled="activeOrderKey <= 0"
                 class="tm-light tm-light-hover uk-button uk-button-small-padding uk-button-success"
                 role="button"
                 data-uk-tooltip="title: Предыдущий заказ"
                 @click="prevOrder">
                <span class="material-icons">chevron_left</span>
              </a>
            </div>
            <div>
              <a href="#"
                 :disabled="activeOrderKey >= (activeOrders.length-1)"
                 class="tm-light tm-light-hover uk-button uk-button-small-padding uk-button-success"
                 role="button"
                 data-uk-tooltip="title: Следующий заказ"
                 @click="nextOrder">
                <span class="material-icons">chevron_right</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <a href="#" class="uk-position-top-right tm-dialog-close"  @click="closeDialogOrder()">
        <span class="material-icons">close</span>
      </a>
      <v-tabs-items v-model="tabInfo">
        <v-tab-item style="min-height: 600px; max-height: 80vh; overflow-y: auto;">
          <v-card flat>
            <v-card-text>
              <div v-if="loadingOrderView">
                <v-progress-circular
                    :width="2"
                    indeterminate
                    style="color: forestgreen"></v-progress-circular>
              </div>
              <div class="uk-padding uk-position-relative tm-modal-page">
                <div class="uk-grid uk-flex-middle" data-uk-grid>
                  <div class="uk-width-auto">
                    <h4>{{ this.local_page_keys.order_number }}: {{ currendOrderId }}</h4>
                  </div>
                </div>
                <div class="uk-margin" v-if="!activeOrderReload">
                  <OrderView></OrderView>
                </div>
                <hr class="uk-margin-medium">
                <h4 class="uk-margin">{{local_page_keys.title_previous_orders}}:</h4>
                <prev-orders-block-for-admin :currentOrderId="currendOrderId"></prev-orders-block-for-admin>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item style="min-height: 600px; max-height: 80vh; overflow-y: auto;">
          <v-card flat>
            <v-card-text>
              <div class="uk-padding uk-position-relative tm-modal-page">
                <div class="text-center">
                  <md-dialog-title>
                    {{ local_page_keys.order_history_info_dialog_title }}№ {{ modal_info.order_number }}
                  </md-dialog-title>
                </div>
                <md-dialog-content>
                  <div v-if="loadingOrderHistoryInfo">
                    <v-progress-circular
                        :width="2"
                        indeterminate
                        style="color: forestgreen"></v-progress-circular>
                  </div>
                  <div v-if="Object.keys(modal_info).includes('info_table')" class="uk-margin">
                    <md-table>
                      <md-table-row>
                        <md-table-head v-for="header of headersInfoTable" :key="header.id" :label="header.text">
                          {{ header.text }}
                        </md-table-head>
                      </md-table-row>
                      <md-table-row>
                        <md-table-cell v-for="header of headersInfoTable" :key="header.id">
                          <template v-if="(header.value === 'last_retoucher' || header.value === 'last_pro_retoucher')">
                            {{ modal_info.info_table[header.value] === '' ? modal_info.info_table[header.value] : modal_info.info_table[header.value].name }}
                          </template>
                          <template v-else>
                            {{ modal_info.info_table[header.value] }}
                          </template>
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </div>
                  <div v-if="Object.keys(modal_info).includes('particular_table')" class="uk-margin">
                    <div class="text-center" v-if="!showParticularInfoTable">
                      <button class="btn btn-outline-primary" @click="showParticularInfoTable = !showParticularInfoTable">
                        {{ local_page_keys.modal_button_show_particular_table }}
                      </button>
                    </div>
                    <div v-else>
                      <div class="text-center">
                        <button class="btn btn-outline-dark" @click="showParticularInfoTable = !showParticularInfoTable">
                          {{ local_page_keys.modal_button_hide_particular_table }}
                        </button>
                      </div>
                      <md-table>
                        <md-table-row>
                          <md-table-head v-for="header of headersParticularInfoTable" :key="header.id" :label="header.text">
                            {{ header.text }}
                          </md-table-head>
                        </md-table-row>
                        <md-table-row v-for="item of sortByDate(modal_info.particular_table)" :key="item.id">
                          <md-table-cell v-for="header of headersParticularInfoTable" :key="header.id">
                            {{ item[header.value] }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                  </div>
                </md-dialog-content>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </md-dialog>

  </div>
</template>

<script>
import ScheduleTable2RetoucherItem from "../../Dashboard/Components/ScheduleTable2RetoucherItem.vue";
import Pagination from "@/components/Pagination";
import AdminCalendarComponent from "../../../components/AdminCalendarComponent.vue";
import OrderView from "@/pages/Dashboard/Pages/OrderView";
import PrevOrdersBlockForAdmin from "@/pages/Dashboard/Components/Admin/PrevOrdersBlockForAdmin";
export default {
  components: {Pagination, AdminCalendarComponent, ScheduleTable2RetoucherItem, OrderView, PrevOrdersBlockForAdmin},
  data() {
    return {
      selectObj: '',
      selectObjId: '',
      page: null,
      week: null,
      schedules: [],
      role: '',
      view: 'retoucher',
      retoucher: "",
      users_list: [],
      users_to_choose: [],
      loading: true,
      timeControl: [],
      ordersDelay: {},
      hours: null,
      empty_schedule: '',
      local_page_keys: {},
      countOrders: null,
      getterKey: 0,
      current_shift: null,
      keyLockIsChecked:{},
      keyLockIstoSet: false,
      updatePopupId: null,
      selectedDelay: {
        id:null,
        delay_json:null
      },
      isDelayLoading: false,
      showDialogOrder: false,
      tabInfo: null,
      modal_info: {},
      loadingOrderHistoryInfo: true,
      showParticularInfoTable: false,
      headersInfoTable: [],
      headersParticularInfoTable: [],
      currendOrderId:null,
      loadingOrderView:true,
      activeOrderReload: false,
      activeButtonId:'',
      currentPopupId:'',
      activeOrders: [],
      activeOrderKey: null,
    };

  },
  watch: {
    combinedValues:{
      immediate: false,
      handler(newValue, oldValue) {
        // Handle changes in combinedValues
        this.$nextTick(() => {
          // Logic to execute after the page has re-rendered
          if(typeof newValue[0] == 'object' && typeof newValue[1] == 'string'){
            setTimeout(function(){
              UIkit.dropdown(document.getElementById(newValue[1])).show();
            },2100);
          }
        });
      }
    }
  },

  methods: {
    // keyLockToggleCheck(event, day, item, email){
    //
    //   console.log( event.target.checked);
    //   console.log(email);
    //   console.log(event.target.checked ? 2 : 1);
    //
    //   console.log(day);
    //   console.log(item);
    //   this.set(this.keyLockIsChecked, [item, day, email,'set_to_work'], event.target.checked ? 2 : 1);
    //   this.$forceUpdate();
    //   console.log(this.keyLockIsChecked[item][day][email]);
    //
    //
    // },
    filterDaysToShow(days){
      //console.log(days);
      if(days.length = 19) days = days.slice(4, -5);
      return days;
    },
    set(obj, path, value) {
      var schema = obj;  // a moving reference to internal objects within obj
      var pList = path;
      var len = pList.length;
      for(var i = 0; i < len-1; i++) {
        var elem = pList[i];
        if( !schema[elem] ) schema[elem] = {}
        schema = schema[elem];
      }

      schema[pList[len-1]] = value;
    },
    setKeyLockIsChecked(schedule){
      if(Object.keys(schedule).length > 0){
        for (let scheduleByTime in schedule) {
          if(Object.keys(schedule[scheduleByTime]).length > 0) {
            for (let scheduleByDate in schedule[scheduleByTime]) {
              if(schedule[scheduleByTime][scheduleByDate].length > 0){
                //console.log(schedule[scheduleByTime][scheduleByDate].length);
                for(let option of schedule[scheduleByTime][scheduleByDate]){
                  if(typeof option['set_to_work'] != 'undefined' && typeof option['email'] != 'undefined'){
                    this.set(this.keyLockIsChecked, [scheduleByTime,scheduleByDate,option['email'],'set_to_work'], option['set_to_work'])
                  }
                }
              }

            }
          }
        }
      }
    },
    async fetchSchedules() {
      if (!this.loading) {
        this.loading = true;
      }
      try {
        await this.$store.dispatch("schedule/scheduleMaria");
        //let scheduleMaria = await this.$store.getters['schedule/scheduleMaria'];
        this.getterKey++;
        let schedule = await this.$store.getters['schedule/scheduleMaria'](this.getterKey);
        // await this.$store.dispatch("schedule/schedule");
        // let scheduleOld = await this.$store.getters['schedule/schedule'];
        // console.log('scheduleOld', scheduleOld);
        //console.log('schedule', schedule);
        //schedule = scheduleMaria;
        if (schedule.empty_schedule) {
          this.empty_schedule = schedule.empty_schedule;
          this.loading = false;
        } else {
          this.schedules = Object.entries(schedule.schedule);
          this.setKeyLockIsChecked(schedule.schedule);
          this.users_to_choose = schedule.users_to_choose;
          this.week = Number(schedule.week);
          this.page = this.week;
          this.current_shift = schedule.current_shift;
          this.timeControl = schedule.timeControl;
          this.ordersDelay = schedule.ordersDelay;
          this.hours = schedule.hours;
          this.countOrders = schedule.total;
          this.loading = false;
          if (this.isAdmin()) {
            // await this.fetchUsersList();
            if (schedule.retouchers) {
              this.formatUsersList(schedule.retouchers);
            }
            this.addHeaderToolTip();
          } else {
            this.addHeaderToolTipForRetouchers();
          }
        }
      } catch (e) {
        alert(e);
      }
    },
    async fetchPageSchedules(page, year) {
      this.loading = true;
      if (this.retoucher === '') {
        try {
          await this.$store.dispatch("schedule/schedulePageMaria", {page, year});
          this.getterKey++;
          let schedulePage = await this.$store.getters["schedule/schedulePageMaria"](this.getterKey);
          // await this.$store.dispatch("schedule/schedulePage", page);
          // let schedulePage = await this.$store.getters["schedule/schedulePage"];
          // console.log('schedulePage', schedulePage);

          if (schedulePage.empty_schedule) {
            this.empty_schedule = schedulePage.empty_schedule;
            this.loading = false;
          } else {
            this.users_to_choose = schedulePage.users_to_choose;
            this.schedules = Object.entries(schedulePage.schedule);
            this.setKeyLockIsChecked(schedulePage.schedule);
            this.hours = schedulePage.hours;
            this.timeControl = schedulePage.timeControl;
            this.ordersDelay = schedulePage.ordersDelay;
            this.countOrders = schedulePage.total;
            if (this.isAdmin()) {
              if (schedulePage.retouchers) {
                this.formatUsersList(schedulePage.retouchers);
              }
              this.addHeaderToolTip();
              // await this.fetchUsersList();
            } else {
              this.addHeaderToolTipForRetouchers();
            }
            this.loading = false;
          }
        } catch (e) {
          alert(e);
        }
      } else {
        try {
          let retoucher = this.retoucher;
          let params = {retoucher, page, year}
          // console.log(retoucher);
          // return false;
          // await this.$store.dispatch("schedule/scheduleAdminPage", params);
          // let scheduleAdminPage = await this.$store.getters["schedule/scheduleAdminPage"];
          await this.$store.dispatch("schedule/scheduleAdminPageMaria", params);
          this.getterKey++;
          let scheduleAdminPage = await this.$store.getters["schedule/scheduleAdminPageMaria"](this.getterKey);
          // console.log('scheduleAdminPage',scheduleAdminPage);
          // console.log('scheduleAdminPageMaria', scheduleAdminPageMaria);
          if (scheduleAdminPage.empty_schedule) {
            this.empty_schedule = scheduleAdminPage.empty_schedule;
            this.loading = false;
          } else {
            this.schedules = Object.entries(scheduleAdminPage.schedule);
            this.setKeyLockIsChecked(scheduleAdminPage.schedule);
            this.hours = scheduleAdminPage.hours;
            this.loading = false;
          }
        } catch (e) {
          alert(e);
        }
      }
    },
    async fetchSchedulesAdmin(user_email) {
      if (!this.loading) {
        this.loading = true;
      }
      try {
        // await this.$store.dispatch("schedule/scheduleAdmin", user_email);
        // let scheduleAdminOld = await this.$store.getters["schedule/scheduleAdmin"];
        await this.$store.dispatch("schedule/scheduleAdminMaria", user_email);
        this.getterKey++;
        let scheduleAdmin = await this.$store.getters["schedule/scheduleAdminMaria"](this.getterKey);
        //console.log(scheduleAdmin);
        // console.log(scheduleAdminOld);
        if (scheduleAdmin.empty_schedule) {
          this.empty_schedule = scheduleAdmin.empty_schedule;
          this.loading = false;
        } else {
          this.schedules = Object.entries(scheduleAdmin.schedule);
          this.setKeyLockIsChecked(scheduleAdmin.schedule);
          this.week = Number(scheduleAdmin.week);
          this.page = this.week;
          this.hours = scheduleAdmin.hours;
          this.loading = false;
        }
      } catch (e) {
        alert(e);
      }
    },
    async fetchUsersList() {
      await this.$store.dispatch("schedule/usersList");
      let usersList = await this.$store.getters['schedule/usersList'];
      if (usersList) {
        let users_list = [];
        users_list.push({
          "text": this.local_page_keys.text_users_list_all_retouchers,
          "value": "все ретушеры",
          "class": "all-retouchers"
        })
        for (let i = 0; i < usersList.length; i += 1) {
          users_list.push({
            "text": '<' + usersList[i].user_email + '>' + ' -  ' + usersList[i].user_name,
            "value": usersList[i].user_email,
            "class": "retaucher-"+i
          });
        }
        this.users_list = users_list;
      } else {
        this.errors = this.local_page_keys.alert_failed_users_list;
      }
    },
    formatUsersList(usersList) {
      let result = [];
      result.push({
        "text": this.local_page_keys.text_users_list_all_retouchers,
        "value": "все ретушеры",
        "class": "all-retouchers"
      })
      for (let i = 0; i < usersList.length; i += 1) {
        result.push({
          "text": usersList[i].text,
          "value": usersList[i].value,
          "class": "retaucher-"+i
        });

      }
      this.users_list = result;
    },
    /**
     * @param day
     * @param date
     * @param time
     * @returns {*[]}
     */

    getRetoucherTime: function (day, date, time) {
      var workers = [];
      var workersBlack = [];

      for (var i in day) {
        if (day[i].name !== '' && day[i].email !== '' && (day[i].role === 'retoucher' || day[i].role === 'junior-retoucher')) {
          const working_time = (this.isPast(date, time) ? day[i].time : false);
          const waiting_minutes = (this.isPast(date, time) ? day[i].waiting_minutes : 0);
          let obj = {
            'name': day[i].name,
            'user_id': day[i].user_id,
            'email': day[i].email,
            'must': day[i].must,
            'replace': day[i].replace,
            'photos_per_hour': day[i].photos_per_hour ? day[i].photos_per_hour : 0,
            'role': day[i].role,
            'points': day[i].points,
            'set_to_work': day[i].set_to_work,
            'time': working_time,
            'waiting_minutes': waiting_minutes,
            'done_orders': (day[i].done_orders && this.isPast(date, time) ? day[i].done_orders : 0),
            'order_done_in_shift': (day[i].order_done_in_shift && this.isPast(date, time) ? day[i].order_done_in_shift : 0)
          };

          if ( (!day[i].set_to_work || day[i].set_to_work == 0) && day[i].done_orders >= 0){
            if(Number(working_time) > 0 || Number(waiting_minutes) > 0){
              workersBlack.push(obj);
            }


          } else {
            workers.push(obj);
          }


        }
      }

      return workers.concat(workersBlack);
    },
    /** Method for send subscribe-unsubscribe or replace-cancel replace requests to ScheduleController
     * to methods update - route api/v1/schedule/update,
     *    and replace - route api/v1/schedule/update/replace.
     *  arguments: date - type: string, format - 'YYYY-mm-dd' - date for update or replace
     *       time - type: string, format - 'hh:mm - hh:mm' - time for update or replace
     *       msg - type: string - may be: subscribe, unsubscribe, replacement, cancell of replacement, cancell of replacement by admin,
     *       email - type: string, format - email - email of user for whom make request
     * identifiable data: selectObjId - is emty string - for cancel choosen user,
     *           selectObj - is emty string - for cancel choosen user,
     *           schedules - object which formed in ScheduleController by method: for retoucher and admin (if current page number matches the current week) - index;
     *                 for admin only - indexPagination (if current page number does not matches the current week)
     *                          or index_Request (if admin has selected user and current page number matches the current week)
     *                          or indexPagination_Request (if admin has selected user and current page number does not matches the current week),
     *           hours - object which formed in ScheduleController by methods mentioned above,
     *           timeControl - object which formed in ScheduleController by methods mentioned above,
     *
     * */
    async showDialog(date, time, msg, email, name, dataToUpdate, dataToRestore) {
      this.updatePopupId = 'tm-scheduletable-dropdown-'+date+time;
      //console.log(this.getWeek(date), this.page, this.page);
      //let week = (this.page === this.week ? '' : this.page);//define is current page number matches the current week
      let week = this.page;//define is current page number matches the current week
      let retoucher = '';
      if (!email) {
        retoucher = this.retoucher;
      } else {
        retoucher = email;
      } //define has admin chose retoucher
      let view = this.view;//define in which view we are now (admin or retoucher)
      let message = '';
      let urlToUpdate = '';
      //messages of confirm and url are generated depending on the role and msg
      if (msg === 'unsubscribe' || msg === 'subscribe' || msg === 'cancell of replacement by admin' || msg === 'update') {
        if (msg === 'unsubscribe') {
          if (this.isAdmin()) {
            message = this.local_page_keys.alert_are_you_sure_you_want_to_take_this_retoucher_off_duty_on_this_date+' ' + date + ' '+this.local_page_keys.label_time+' ' + time + '?';
          } else {
            message = this.local_page_keys.alert_are_you_sure_you_want_to_unsubscribe_from_duty_on_this_date+' ' + date + ' '+this.local_page_keys.label_time+' ' + time + '?';
          }
        } else if (msg === 'subscribe') {
          if (this.isAdmin()) {
            message = this.local_page_keys.alert_are_you_want_to_sign_this_retoucher_up_for_duty_on_this_date+' ' + ' '+this.local_page_keys.label_time+' ' + time + '?';
          } else {
            message = this.local_page_keys.alert_you_want_to_sign_this_retoucher_up_for_duty_on_this_date+' ' + ' '+this.local_page_keys.label_time+' ' + time + '?';
          }
        } else if(msg === 'update'){
          if (this.isAdmin()) {
            message = this.local_page_keys.alert_are_you_want_to_update_this_retoucher_duty_on_this_date + ' ' + ' ' + this.local_page_keys.label_time + ' ' + time + '?';
          } else {
            message = this.local_page_keys.alert_you_want_to_update_this_retoucher_duty_on_this_date + ' ' + ' ' + this.local_page_keys.label_time + ' ' + time + '?';
          }
        } else if (msg === 'cancell of replacement by admin') {
          message = this.local_page_keys.alert_retoucher_has_asked_for_a_replacement_and_a_replacement_has_not_yet_been_found;
        }
        //urlToUpdate = '/schedule/update';
        urlToUpdate = '/schedule_maria/update';

      } else if (msg === 'replacement' || msg === 'cancell of replacement') {
        if (msg === 'replacement') {
          message = this.local_page_keys.alert_you_are_signed_up_for_this_shift_you_can_not_miss_it;
        } else if (msg === 'cancell of replacement') {
          message = this.local_page_keys.alert_no_replacement_for_this_shift_has_yet_been_found_for_you;
        }
        //urlToUpdate = '/schedule/update/replace';
        urlToUpdate = '/schedule_maria/update/replace';
      }
      //sending request to ScheduleController
      if (confirm(message)) {
        if(msg === 'update' && typeof dataToUpdate == 'object' && Object.keys(dataToUpdate).length > 0){
          if('set_to_work' in dataToUpdate){
            this.set(this.keyLockIsChecked, [time, date, email,'set_to_work'], dataToUpdate.set_to_work);
            const dataToUpdateCheckbox = document.getElementById('keyLockToggleCheckRef-' + time + date + email);
            if (dataToUpdateCheckbox) {
              dataToUpdateCheckbox.checked = dataToUpdate.set_to_work == 2 ? true : false;
            }
          }
        }
        this.cellLoader(date, time, true);
        let keyLockIstoSet = this.keyLockIstoSet;
        this.keyLockIstoSet = false;
        this.selectObjId = '';
        this.selectObj = '';
        let updateParams = {date, time, msg, retoucher, week, view, keyLockIstoSet, dataToUpdate}
        let params = { urlToUpdate, updateParams};
        // console.log(params);
        // return false;
        // await this.$store.dispatch("schedule/scheduleUpdate", params);
        // let updated = await this.$store.getters["schedule/scheduleUpdate";
        await this.$store.dispatch("schedule/scheduleUpdateMaria", params);
        this.getterKey++;
        let updated = await this.$store.getters["schedule/scheduleUpdateMaria"](this.getterKey);
        // console.log(updated)
        // return false;
        if (updated) {
          if (updated.failed) {
            this.cellLoader(date,time,false);
            alert(updated.failed)
          } else {
            this.schedules = Object.entries(updated.schedule);
            this.setKeyLockIsChecked(updated.schedule);

            this.schedules = Object.entries(updated.schedule);//to display data in the main table
            this.cellLoader(date, time, false);
          }
          if (this.isAdmin() && !this.isAdminView()) {
            // setTimeout(function(){
            //   UIkit.dropdown(document.getElementById('tm-scheduletable-dropdown-'+date+time)).show();
            // },250);
          } else {
            this.hours = updated.hours;//for define is may to subscribe or not
            this.timeControl = updated.timeControl;//to determine the fulfillment of work-plan
          }
        }
      }
      else {
        if(msg === 'update' && typeof dataToRestore == 'object' && Object.keys(dataToRestore).length > 0){
          if('set_to_work' in dataToRestore){
            this.set(this.keyLockIsChecked, [time, date, email,'set_to_work'], dataToRestore.set_to_work);
            const dataToRestoreCheckbox = document.getElementById('keyLockToggleCheckRef-' + time + date + email);
            if (dataToRestoreCheckbox) {
              dataToRestoreCheckbox.checked = dataToRestore.set_to_work == 2 ? true : false;
            }

          }
          // if('set_to_work' in dataToUpdate){
          //   this.set(this.keyLockIsChecked, [time, date, email,'set_to_work'], !dataToUpdate.set_to_work);
          //   this.$forceUpdate();
          // }
        }
      }
      this.updatePopupId = null;
    },
    /**
     * determines whether the current page number equals the current week number
     * @param page - type: number - number of current page
     * @returns {string} - determines class of active page
     */
    currentPage(page) {
      if (page === this.week) {
        return 'success';
      } else {
        return 'primary';
      }
    },
    /**
     * method to change pages in pagination-component
     * determines wbich info will be display on schedule page
     * @param event - type: number - number of changing page
     */
    changePage(event) {
      let year;
      if(typeof event == 'object'){
        this.retoucherView = event.retoucherView;
        year = event.year;
        event = event.page;
      }
      //console.log(year);
      this.page = event;
      if (this.page !== this.week) {
        this.empty_schedule = '';
        this.fetchPageSchedules(event, year);
      } else if (this.page === this.week && this.retoucher === '') {
        this.empty_schedule = '';
        this.fetchSchedules();
      } else if (this.page === this.week && this.retoucher !== '') {
        this.empty_schedule = '';
        this.fetchSchedulesAdmin(this.retoucher);
      }
    },
    /**
     * difines labels for columns in ScheduleTable
     * @param info - string of date in format "YYYY-mm-dd"
     * @returns {string}
     */
    getLabel(info) {
      let date = new Date(info);//make  date-format data
      let dayWeek = this.getWeekDay(date);//determines the names of the days of the week
      let thisDayImg = info == this.getCurrentDate() ? '🔥': ''; //в заголовке таблицы
      return (info + `\r\n` + dayWeek + thisDayImg  ); //determines label of column of table
    },

    currentShift(day, time){
      //console.log(day,time, this.current_shift);
      if(this.current_shift && 'date_hours' in this.current_shift && (day + ' ' + time).indexOf(this.current_shift.date_hours) > -1) {
        return '🔥'; //в ячейках таблицы
      }
    },

    currentShiftTime(time){
      //console.log(day,time, this.current_shift);
      if(this.current_shift && 'hours' in this.current_shift && (time).indexOf(this.current_shift.hours) > -1) {
        return '🔥'; //ячейки в первой колонке
      }
    },

    getCurrentDate(){
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    },

    getCountOrder(info) {
      return this.countOrders && this.countOrders[info] && this.countOrders[info] ?
          " (" + (this.countOrders[info]['previous'] > 0 ? this.countOrders[info]['previous'] : 0)
          + " - "
          + (this.countOrders[info]['current'] > 0 ? this.countOrders[info]['current'] : 0) +")"
          : "";
    },
    /**
     * remake string date and time to date-time data format
     * @param date - string
     * @param time - string
     * @returns {*} - date-time data format
     */
    getFormatDateTime(date, time) {
      let hour = 0;
      if (time) {
        hour = this.getHour(time);
        hour = Number(hour);
        if (hour === 0) {
          hour = 24;
        }
      }
      let year = Number(date.substring(0, 4));
      let month = Number(date.substring(5, 7));
      let day = Number(date.substring(8, 10));
      if (hour != 0) {
        return new Date(year, (month - 1), day, (hour - 1));
      } else {
        return new Date(year, (month - 1), day);
      }
    },
    isPast(date, time) {
      let currdateTime = this.getFormatDateTime(date, time);
      let today = new Date();
      if (((Number(currdateTime.getTime()) - Number(today.getTime())) / (60 * 60 * 1000)) < 0) {
        return true;
      } else {
        return false;
      }
    },
    isAdmin() {
      if (this.role === 'admin' || this.role === 'mini-admin' || this.role === 'senior-retoucher') {
        return true;
      } else {
        return false;
      }
    },
    isAdminView() {
      if (this.isAdmin() && (this.view === "admin" || this.view === "mini-admin" || this.view === 'senior-retoucher')) {
        return true;
      } else {
        return false;
      }
    },
    getClass: function (info) {
      let date = new Date(info)
      let today = new Date();
      let newClass = '';

      if (date.toLocaleDateString() === today.toLocaleDateString()) {
        newClass = "today ";
      }
      newClass = newClass + "font"
      return newClass;
    },

    getWeekDay(date) {
      let days = [this.local_page_keys.label_day_week_sunday+' 👑', this.local_page_keys.label_day_week_monday, this.local_page_keys.label_day_week_tuesday, this.local_page_keys.label_day_week_wednesday, this.local_page_keys.label_day_week_thursday, this.local_page_keys.label_day_week_friday,  this.local_page_keys.label_day_week_saturday+' 👑'];

      return days[date.getDay()];
    },

    getWeek(date) {
      // Copy date so don't modify original
      const d = new Date(date);
      // Set to nearest Thursday
      d.setHours(0, 0, 0);
      d.setDate(d.getDate() + 4 - (d.getDay() || 7));
      // Get first day of year
      const yearStart = new Date(d.getFullYear(), 0, 1);
      // Calculate full weeks to nearest Thursday
      const weekNumber = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
      return weekNumber;
    },

    getHour(time) {
      return time.slice(-6);
    },
    isMember(data) {
      if (this.role === 'admin' || this.role === 'mini-admin' || this.role === 'senior-retoucher') {
        for (let item of data) {
          if (item.email !== '' && item.set_to_work > 0) {
            let workingTime = typeof (item.time) !== 'boolean' ? Number(item.time) : 0;
            let waitingTime = typeof (item.waiting_minutes) !== 'boolean' ? Number(item.waiting_minutes) : 0;
            return (workingTime + waitingTime) >= 0 ? true: false;
          }
        }
      } else {
        if (data[0].time !== false && data[0].set_to_work > 0) {
          return true;
        } else {
          return false;
        }
      }
    },
    isFakeMember(data){
      if (this.role === 'admin' || this.role === 'mini-admin' || this.role === 'senior-retoucher') {
        for (let item of data) {
          if (item.email !== '') {
            return (!item.wasWritten || item.wasWritten == 0) && item.done_orders > 0 ;

          }
        }
      }else {
        return (!data[0].wasWritten || data[0].wasWritten == 0) && data[0].done_orders > 0 ;

      }
    },
    getTime(data) {
      for (let item of data) {
        if (item.email !== '') {
          if ((typeof (item.time) !== 'boolean') || (typeof (item.waiting_minutes) !== 'boolean')) {
            let workingTime = typeof (item.time) !== 'boolean' ? Number(item.time) : 0;
            let waitingTime = typeof (item.waiting_minutes) !== 'boolean' ? Number(item.waiting_minutes) : 0;
            return workingTime + waitingTime;
          } else {
            return 0;
          }
        }
      }
    },
    getWaitingTime(data, returnObj = false){
      for (let item of data) {
        if (item.email !== '') {
          let doneOrders = typeof (item.done_orders) !== 'boolean' ? Number(item.done_orders) : 0;
          let waitingTime = typeof (item.waiting_minutes) !== 'boolean' ? Number(item.waiting_minutes) : 0;
          if(returnObj) return {doneOrders:doneOrders, waitingTime:waitingTime};
          return '#' + doneOrders + ' 🕛' + waitingTime;
        } else {
          return '';
        }
      }

    },
    getClassBattery(data, day = null) {
      let batteryClass = '';
      if (data === 0) {
        if(day && day[0].done_orders > 0){
          batteryClass = ' tm-battery-black';
        } else {
          batteryClass = 'border-red';
        }
      } else if (data >= 1 && data <= 15) {
        batteryClass = 'color-red';
      } else if (data >= 16 && data <= 29) {
        batteryClass = 'color-yellow';
      } else if (data >= 30 && data <= 45) {
        batteryClass = 'color-low-green';
      } else if (data >= 46) {
        batteryClass = 'color-green';
      } else {
        batteryClass = '';
      }
      return batteryClass;
    },
    getDiscBattery2(data) {
      let batteryDiscription = '';
      if (data === 0) {
        batteryDiscription = this.local_page_keys.scheduletable_empty_disc;
      } else if (data >= 1 && data <= 15) {
        batteryDiscription = this.local_page_keys.scheduletable_1_15_min;
      } else if (data >= 16 && data <= 29) {
        batteryDiscription = this.local_page_keys.scheduletable_16_29_min;
      } else if (data >= 30 && data <= 45) {
        batteryDiscription = this.local_page_keys.scheduletable_30_45_min;
      } else if (data >= 46) {
        batteryDiscription = this.local_page_keys.scheduletable_46_min_and_more;
      } else {
        batteryDiscription = '';
      }
      return batteryDiscription;
    },
    mayToWrite(data) {
      let today = new Date();
      let dayToWrite = this.getFormatDateTime(data);
      let diff = (dayToWrite.getTime() - today.getTime()) / (60 * 60 * 24 * 1000);
      if (diff > 3) {
        return true;
      } else {
        return false;
      }
    },
    mustCancelReplace(data) {

      if (!this.isAdmin() || this.isAdminView()) {
        if (Object.entries(data)[0][1].replace) {
          return true;
        } else {
          return false;
        }
      } else {
        if (data.replace) {
          return true;
        } else {
          return false;
        }
      }

    },
    mayToReplace(data) {
      if (!Object.entries(data)[0][1].must) {
        return true;
      } else {
        return false;
      }
    },
    isNight(data) {
      const night = [
        '00.00 - 01.00',
        '01.00 - 02.00',
        '02.00 - 03.00',
        '03.00 - 04.00',
        '04.00 - 05.00',
        '05.00 - 06.00',
      ];
      return night.includes(data) ? true : false;
    },
    changeUser(selectObj) {
      this.loading = true;
      if (selectObj === 'все ретушеры') {
        this.empty_schedule = '';
        this.view = "retoucher";
        this.retoucher = "";
        this.fetchSchedules();
      } else {
        this.empty_schedule = '';
        this.view = "admin";
        this.retoucher = selectObj;
        this.fetchSchedulesAdmin(selectObj);
      }
    },
    getBackground(data,delay) {
      let setClass = '';
      let isDelayClass = delay && Object.entries(delay).length ? 'tm-scheduletable-dropdown-3'  : '';
      if (data !== undefined && data.color) {
        // if (data.color === "md-success") {
        if (data.color === "md-success tm-button-scheduletable-success") {
          setClass = 'tm-green-list';
          // } else if (data.color === "md-yellow") {
        } else if (data.color === "md-yellow tm-button-scheduletable-yellow") {
          setClass = 'tm-yellow-list';
          // } else if (data.color === "md-warning") {
        } else if (data.color === "md-warning tm-button-scheduletable-warning") {
          setClass = 'tm-orange-list';
        }
      }
      return setClass + ' ' + isDelayClass;
    },
    backToCurrWeek() {
      if (this.retoucher === '') {
        this.fetchSchedules();
      } else {
        this.fetchSchedulesAdmin(this.retoucher);
      }
    },
    async getRole() {
      await this.$store.dispatch("profile/role");
      this.role = await this.$store.getters["profile/role"];

    },
    selectUser(selectObj) {
      this.selectObj = selectObj.target.value;
      //console.log(this.selectObj);
    },
    getUsersList(time, date) {
      return this.users_to_choose[time][date];
    },
    changeOneCell(date, time, msg, retoucher, name, updated) {
      this.cellLoader(date,time,false);
      let elementId = date + time;
      // let usersList = this.getUsersList(time, date);
      let selectId = 'select' + elementId;
      let selectorId = "[id='" + retoucher + "']";
      let dataAttribute = document.getElementById(elementId).attributes[0].name;
      // let buttonSelect = document.getElementById('button-' + date + time);
      let itemText = "<" + retoucher + "> - " + name;
      if (msg === 'unsubscribe' || msg === 'cancell of replacement by admin') {
        let elem =  document.getElementById(elementId);
        let nodes = elem.childNodes;
        for (let item in nodes) {
          if (nodes[item].nodeName === 'UL') {
            let listItems = nodes[item].childNodes
            for(let li in listItems) {
              if (listItems[li].nodeName === 'LI') {
                if (listItems[li].innerText.includes(name)) {
                  listItems[li].remove();
                }
              }
            }
          }
        }
        let users_to_choose = this.users_to_choose[time][date];
        let user_to_add = {};
        user_to_add.name = name;
        user_to_add.text = itemText;
        user_to_add.value = retoucher
        users_to_choose.splice(0, 0, user_to_add);
        // this.users_to_choose = updated.users_to_choose;
      } else if(msg == 'subscribe') {
        if (document.getElementById(elementId).querySelector(selectorId) == null){
          let selectorValue = "[value='"+retoucher+"']";
          let retoucher_name = document.getElementById(selectId).querySelector(selectorValue).getAttribute('name');
          let role = '';
          let points = 0;
          for (let workers in updated[time][date]) {
            if (updated[time][date][workers]['email'] === retoucher) {
              role = updated[time][date][workers]['role'];
              points = updated[time][date][workers]['points'];
            }
          }
          var ul = document.getElementById(elementId).firstChild;

          var li = document.createElement("li");
          var span1 = document.createElement('span');
          var span2 = document.createElement('span');
          var span3 = document.createElement('span');
          if (role === 'retoucher') {
            span3.innerText = '(' + points + ')';
          } else {
            span3.innerText = '(test 0)';
          }

          li.setAttribute(dataAttribute, "")
          li.classList.add("retoucher-item");

          span1.setAttribute('id',   retoucher);
          span1.setAttribute(dataAttribute, "");
          span1.innerText = retoucher_name;
          span2.setAttribute(dataAttribute, "");
          span2.classList.add("itemTime", "pointer");
          span2.innerHTML = '<i data-v-88139ce8="" class="md-icon md-icon-font md-theme-default">arrow_left</i>';
          span2.addEventListener("click", () => {
            this.showDialog(date, time, 'unsubscribe', retoucher, retoucher_name);
          });
          li.appendChild(span1);
          li.appendChild(span3);
          li.appendChild(span2);
          ul.appendChild(li);
          var select = document.getElementById(selectId);

          let users_to_choose = this.users_to_choose[time][date];
          let removeIndex = users_to_choose.findIndex(function (user) {
            return user.value == retoucher;
          });
          users_to_choose.splice(removeIndex, 1);
          this.users_to_choose[time][date] = users_to_choose;

          select.querySelector(selectorValue).remove();
        }
      }
    },
    cellLoader(date, time, action) {
      let cell_loader = document.getElementById("cell-loader-" + date + time);
      if (action === true) {
        cell_loader.classList.add("show");
      } else {
        cell_loader.classList.remove("show");
        // cell_loader.classList.add("hide");
      }
    },
    delayLoader(date, time, action) {
      if (time && date) {
        let delay_loader = document.getElementById("delay-loader-" + date + time);
        if (action === true) {
          delay_loader.classList.add("show");
          this.isDelayLoading = true;
        } else {
          delay_loader.classList.remove("show");
          this.isDelayLoading = false;
        }
      }
    },
    addHeaderToolTip(){
      let _this = this;
      setTimeout(() => {
        const scheduleDatesKeys = Object.keys(_this.schedules[1][1]);
        const headerLabels = document.getElementsByClassName('md-table-head-label');
        if(headerLabels.length > 0){
          let counter = -1;
          for( const headerLabelsOption of headerLabels){
            const date = scheduleDatesKeys[counter];
            if(date && date in _this.countOrders){
              const countValues = _this.countOrders[date];
              const current = countValues.current;
              const previous = countValues.previous;
              const weekendText = _this.isWeekend(date) ? '👑 ' + _this.local_page_keys.schedule_tooltip_crown_description.replace(/\n/g, '') : '';
              headerLabelsOption.setAttribute('data-uk-tooltip', 'title: ' + previous + ' - число заказов в этот день неделю назад<br>' + current + ' - число заказов на ' + date  + '<br>' + weekendText + '; pos: right; offset: 5; cls: uk-active tm-button-scheduletable-tooltip; delay: 0;');
            }
            counter++;
          }
        }
      }, 1000);
    },
    addHeaderToolTipForRetouchers(){
      let _this = this;
      setTimeout(() => {
        const scheduleDatesKeys = Object.keys(_this.schedules[1][1]);
        const headerLabels = document.getElementsByClassName('md-table-head-label');
        if(headerLabels.length > 0){
          let counter = -1;
          for( const headerLabelsOption of headerLabels){
            const date = scheduleDatesKeys[counter];
            if(date && date in _this.countOrders){
              const weekendText = _this.isWeekend(date) ? '👑 ' + _this.local_page_keys.schedule_tooltip_crown_description.replace(/\n/g, '') : '';
              if (weekendText) {
                headerLabelsOption.setAttribute('data-uk-tooltip', 'title: ' + weekendText + '; pos: right; offset: 5; cls: uk-active tm-button-scheduletable-tooltip; delay: 0;');
              }
            }
            counter++;
          }
        }
      }, 1000);
    },
    isWeekend(dateString) {
      const date = new Date(dateString);
      const dayOfWeek = date.getDay();
      // 0 - воскресенье, 6 - суббота
      return dayOfWeek === 0 || dayOfWeek === 6;
    },
    toggleDelay(delay, time, date){
      this.delayLoader(date, time, true);
      this.selectedDelay.id = delay.id;
      this.selectedDelay.delay_json = delay.delay_json;
      setTimeout(() => {
        this.delayLoader(date, time, false);
      }, 600);
    },
    initToggleDelay(time,day) {
      this.selectedDelay.id = null;
      this.selectedDelay.delay_json = null;
      this.activeButtonId = 'button-' + day + time;

      let firstDelay = Object.entries(this.ordersDelay[time][day])[0];
      if (firstDelay) {
        this.toggleDelay(firstDelay[1])
      }

      this.currentPopupId = 'tm-scheduletable-dropdown-' + day + time;

      let dataAttribute = document.getElementById(this.activeButtonId);

      if (dataAttribute.classList.contains("tm-active")) {
        dataAttribute.classList.remove("tm-active");
        UIkit.tooltip(dataAttribute).hide();
      } else {
        dataAttribute.classList.add("tm-active");
        UIkit.tooltip(dataAttribute).show();
      }

      if(!(this.currentPopupId in this.currentPopupIdVisited)){
        this.currentPopupIdVisited[this.currentPopupId] = this.timeRoundedToUpper30Seconds
      }
      if(Object.keys(this.currentPopupIdVisited).length > 0) this.setCookie('currentPopupIdVisited', this.currentPopupIdVisited, 14);
    },
    initToggleDelayPopup(time,day) {
      this.activeButtonId = 'button-' + day + time;
      let dataAttribute = document.getElementById(this.activeButtonId);
      dataAttribute.classList.add("tm-active");
    },
    getWaitingIndication(delays) {
      const data = Object.entries(delays);
      const maxTimeDelay = data.reduce((maxValue, currentElement) => {
        const currentTimeDelay = currentElement[1].time_delay;
        return currentTimeDelay > maxValue ? currentTimeDelay : maxValue;
      }, 0);

      let colorClass = "tm-scheduletable-indication ";
      let timeDelay = 0;

      if (maxTimeDelay >= 120) {
        colorClass += "black";
        timeDelay = 120;
      } else if (maxTimeDelay >= 90) {
        timeDelay = 90;
        colorClass += "red";
      } else if (maxTimeDelay >= 45) {
        colorClass += "orange";
        timeDelay = 45;
      } else if (maxTimeDelay >= 30) {
        timeDelay = 30;
        colorClass += "yellow";
      }
      if (timeDelay > 0)
        return `<div class="${colorClass}" data-uk-tooltip="title: Клиенты ждали ${timeDelay}+ минут"></div>`;
    },
    async openOrder(order_id) {
      this.activeOrderReload = true;
      this.loadingOrderView = true;
      this.currendOrderId = parseInt(order_id);
      await this.$store.dispatch('order/setViewOrderId', this.currendOrderId);
      this.showDialogOrder = true;
      this.activeOrderReload = false;
      this.loadingOrderView = false;
      this.showOrderHistory(this.currendOrderId);
      this.selectOrder(order_id);
      location.hash = this.currendOrderId;
    },
    async selectOrder( order_id) {
      let orders = JSON.parse(this.selectedDelay.delay_json);
      if (orders) {
        this.activeOrders = orders.map((order) => {
          return order.order_id ?? null;
        });
      }
      this.activeOrderKey = this.activeOrders.indexOf(order_id);
      //   await this.openOrder(order_id);
    },
    async nextOrder() {
      if (this.activeOrders[this.activeOrderKey + 1]) {
        await this.openOrder(this.activeOrders[this.activeOrderKey + 1]);
        //this.activeOrderKey++;
      }
    },
    async prevOrder() {
      if (this.activeOrders[this.activeOrderKey - 1]) {
        await this.openOrder(this.activeOrders[this.activeOrderKey - 1]);
        //this.activeOrderKey--;
      }
    },
    async showOrderHistory(order_id) {
      this.loadingOrderHistoryInfo = true;
      await this.$store.dispatch('adminOrdersHistory/orderHistoryInfo', {order_id});
      let data = await this.$store.getters['adminOrdersHistory/orderHistoryInfo'];
      if (typeof data === 'object') {
        if (Object.keys(data).includes('info_table')) {
          this.modal_info['info_table'] = data.info_table;
        }
        if (Object.keys(data).includes('particular_table') && data.particular_table.length > 0) {
          this.modal_info['particular_table'] = data.particular_table;
        }
        this.modal_info['order_number'] = this.modal_info.info_table['order_number'];
        this.loadingOrderHistoryInfo = false;
      } else {
        this.loadingOrderHistoryInfo = false;
        this.modal_info['error'] =  data;
      }
    },
    sortByDate(array) {
      let sortedArray = array.sort(function (a, b) {
        let firstDate = new Date(a.date);
        let secondDate = new Date(b.date);
        return firstDate - secondDate;
      })
      return sortedArray;
    },
    getHeaders() {
      this.headersInfoTable = [
        {text: this.local_page_keys.modal_info_table_header_order_id, value: 'order_id'},
        {text: this.local_page_keys.modal_info_table_header_order_number, value: 'order_number'},
        {text: this.local_page_keys.modal_info_table_header_last_retoucher, value: 'last_retoucher'},
        {text: this.local_page_keys.modal_info_table_header_last_pro_retoucher, value: 'last_pro_retoucher'},
        {text: this.local_page_keys.modal_info_table_header_created_at, value: 'created_at'},
        {text: this.local_page_keys.modal_info_table_header_updated_at, value: 'updated_at'},

      ];
      this.headersParticularInfoTable = [
        {text: this.local_page_keys.modal_particular_info_table_header_order_date, value: 'date'},
        {text: this.local_page_keys.modal_particular_info_table_header_order_new_status, value: 'new_status'},
        {text: this.local_page_keys.modal_particular_info_table_header_retoucher_role, value: 'user_role'},
        {text: this.local_page_keys.modal_particular_info_table_header_retoucher_email, value: 'user_email'},

      ];
    },
    isOverWaiting(waiting_minutes, retoucherCount) {
      return waiting_minutes > retoucherCount * 15;
    },
    getToolTip(item, retoucherCount) {
      if (this.isOverWaiting(item.waiting_minutes, retoucherCount)) {
        return 'title: ' +
            item.all + ' - прогнозируемое кол-во заказов на эту смену' +
            '<br>(' + item.use + ') - сумма производительности ретушеров, записанных на смену' +
            '<br>' + item.all_current + ' - фактическое кол-во новых заказов на этой смене' +
            '<br>(' + item.order_done_in_shift + ') - фактическое кол-во заказов, выполненных на этой смене' +
            '<br><span class="tm-text-underline">' + item.waiting_minutes + '</span> - кол-во минут простоя на всех ретушеров, ' +
            '<b>сумма простоя больше числа записанных ретушеров * 10минут</b>' +
            '; pos: right; offset: 5; cls: uk-active tm-button-scheduletable-tooltip; delay: 0;'
      } else {
        return 'title: ' +
            item.all + ' - прогнозируемое кол-во заказов на эту смену' +
            '<br>(' + item.use + ') - сумма производительности ретушеров, записанных на смену' +
            '<br>' + item.all_current + ' - фактическое кол-во новых заказов на этой смене' +
            '<br>(' + item.order_done_in_shift + ') - фактическое кол-во заказов, выполненных на этой смене' +
            '<br><span>' + item.waiting_minutes + '</span> - кол-во минут простоя на всех ретушеров; pos:  right; offset: 5; cls: uk-active tm-button-scheduletable-tooltip; delay: 0;'
      }
    },
    getTimeControlClass(item,day) {
      let isActive = ('button-'+ day + item === this.activeButtonId ) ? ' tm-active' : '';
      return this.timeControl[item][day].color + isActive;
    },
    closeDialogOrder() {
      this.showDialogOrder = false;
      let dataAttribute = document.getElementById(this.currentPopupId);
      UIkit.dropdown(dataAttribute).show();
    }
  },
  async mounted() {
    await this.getRole();
    this.local_page_keys = Object.assign({}, await this.$filtergetLocalisationPage('timetable'), await this.$filtergetLocalisationPage('pro_retoucher_progress_report'),await this.$filtergetLocalisationPage('admin_orders_history'));
    await this.fetchSchedules();
    this.getHeaders();
  },
  computed:{
    combinedValues(){
      return [this.schedules,this.updatePopupId];
    }
  }
}

</script>
<style>

/*JavaScript*/
@import '../../../assets/css/uikit/sticky.css';
@import '../../../assets/css/uikit/dropdown.css';
@import '../../../assets/css/uikit/button.css';
@import '../../../assets/css/uikit/tooltip.css';
@import '../../../assets/css/custom.css';

.pointer {
  cursor: pointer;

}

.width {
  /*width: 80px;*/
  font-weight: bold;
  font-size: 9px;
}

/*.saturday {*/
/*  color: #e4bb6e;*/
/*  font-weight: bold;*/
/*}*/

.font .md-table-head-label {
  font-size: 11px;
}

/*.sunday {*/
/*  color: #ef3939;*/
/*  font-weight: bold;*/
/*}*/

/*.today {*/
/*  !*border-left: solid 1px #4f9b4f;*!*/
/*  !*border-right: solid 1px #4f9b4f;*!*/
/*  background-color: rgba(79, 155, 79, 0.15);*/
/*}*/

.table-transparent {
  background-color: #d28686 !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.schedule .md-table-head:last-child:not(:first-child) .md-table-head-label {
  width: auto;
  /*padding-right: 0;*/
}

/*.schedule .md-table-head:nth-child(8) .md-table-head-label {
  color: #f7c307;
}

.schedule .md-table-head:nth-child(7) .md-table-head-label {
  color: red;
}*/

.md-table .md-table-row:hover .md-table-cell:first-child,
.md-table .md-table-row:hover .md-table-cell{
  background-color: rgba(0,0,0,.07) !important;
}

/*.users_list {*/
/*margin-top: -60px;*/
/*margin-bottom: -50px;*/
/*margin-left: 10%;*/
/*}*/

.v-progress-circular {
  display: block;
  width: 100px;
  margin: 0 auto;
}

/*.retoucher-block {*/
/*  border-color: black;*/
/*}*/





.itemTime {
  min-width: 40px;
  border: 1px solid black;
  text-align: center;
}

.black-text-time {
  color: black !important;
}

.page-item {
  width: auto;
  padding-bottom: 0;
}

.pagination {
  overflow: hidden;
  justify-content: center;
}

.choose-select-for-schedule {
  display: flex;
  justify-content: space-between;
}

.button-for-chooseUser {
  margin: auto !important;
}

.loader-hide {
  display: none;
}

.loader-hide.show {
  display: block;
}

.schedule .md-table-head,
.schedule .md-table-head,
.md-table-head-container,
.md-table-head-label,
.md-table-head-container,
.schedule .md-table-head-container,
.schedule .md-table-head-label,
.schedule .md-table-head-container,
.schedule .md-table-head:last-child:not(:first-child) .md-table-head-label {
  font-size: 11px !important;
}

.schedule .md-table-head,
.schedule .md-table-cell:nth-child(2),
.schedule .md-table-head:nth-child(2),
.schedule .md-table-cell:first-child,
.schedule .md-table-head:first-child {
  max-width: 110px !important;
  min-width: 110px !important;
  width: 110px !important;
}
.schedule .md-table-head,
.schedule .md-table-cell:first-child {
  text-align: center;
}

.md-table-head-container,
.md-table-head-label {
  white-space: normal;
}

.md-table-head-container,
.schedule .md-table-head-container {
  height: auto;
}

.schedule .md-table-head-container,
.schedule .md-table-head-label {
  /*white-space: normal;*/
  padding: 0;
  /*overflow: visible;*/
  height: auto;
  line-height: 1.4;
}

.md-table-head {
  padding: 8px;
  font-size: 12px;
  background-color: #fff;
}
.md-table-head,
.schedule .md-table-head:first-child {
  position: sticky !important;
  top: 0;
  z-index: 1;
}
.md-table-cell {
  padding: 5px;
  //font-size: 12px;
  height: 35px;
}
.admin .md-table-cell {
  height: 41px;
}

.md-table-cell-container .md-button:not(:first-child):not(:last-child) {
  margin-left: 0;
  margin-right: 0;
}

.md-table-fixed-header-container > table,
.md-table-content.md-scrollbar > table {
  table-layout:fixed;
}
.md-content.md-table-content.md-scrollbar.md-theme-default {
  max-height: calc(100vh - 135px);
  overflow: inherit;
}
.admin .md-content.md-table-content.md-scrollbar.md-theme-default {
  max-height: calc(100vh - 95px);
}
.md-table table {
  border-collapse: inherit !important;
  overflow: inherit !important;
}
.footer {
  display: none;
}
/*.content {*/
/*  height: 100vh;*/
/*}*/

.md-card .md-card-content {
  padding: 10px 20px;
}

/* Notebook MDPI */
@media (min-width: 1140px) and (max-width: 1367px) {
  .schedule .md-table-head,
  .schedule .md-table-cell:nth-child(2),
  .schedule .md-table-head:nth-child(2),
  .schedule .md-table-cell:first-child,
  .schedule .md-table-head:first-child {
    max-width: 85px !important;
    min-width: 85px !important;
    width: 85px !important;
  }
  .schedule .md-table-head,
  .schedule .md-table-head,
  .md-table-head-container,
  .md-table-head-label,
  .md-table-head-container,
  .schedule .md-table-head-container,
  .schedule .md-table-head-label,
  .schedule .md-table-head-container,
  .schedule .md-table-head:last-child:not(:first-child) .md-table-head-label {
    font-size: 10px !important;
  }
  .md-table-head,
  .md-table-cell {
    padding: 5px;
    font-size: 10px;
  }

  .uk-button.tm-button-schedule-table {
    padding: 5px;
  }
}
.itemTimePlus{
  padding: 4px;
  font-size: 12px;
}
/*.custom-checkbox input {*/
/*  position: absolute;*/
/*  opacity: 0;*/
/*  pointer-events: none;*/
/*}*/

/*.custom-checkbox md-icon {*/
/*  cursor: pointer;*/
/*}*/
</style>